<template>
    <section class="relative overflow-hidden bg-white py-20">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="grid lg:grid-cols-2 gap-12 items-center">
                <!-- Left: Text Content -->
                <div>
                    <!-- Badge - exact React: inline-block px-4 py-2 bg-primary/10 text-primary rounded-full mb-6 -->
                    <Badge class="mb-6">
                        {{ $t('hero.badge') }}
                    </Badge>

                    <!-- Title and Subtitle -->
                    <div class="space-y-6 mb-8">
                        <h1 class="text-4xl sm:text-5xl lg:text-6xl leading-tight">
                            {{ $t('hero.title') }}
                        </h1>
                        <p class="text-lg text-muted-foreground">
                            {{ $t('hero.subtitle') }}
                        </p>
                    </div>

                    <!-- Bullet Points - exact React: size-5 rounded-full bg-foreground flex items-center justify-center -->
                    <div class="space-y-3 mb-8">
                        <div class="flex items-center gap-3">
                            <div class="size-5 rounded-full bg-foreground flex items-center justify-center shrink-0">
                                <svg class="size-3 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </div>
                            <span class="text-muted-foreground">{{ $t('hero.bullet1') }}</span>
                        </div>
                        <div class="flex items-center gap-3">
                            <div class="size-5 rounded-full bg-foreground flex items-center justify-center shrink-0">
                                <svg class="size-3 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </div>
                            <span class="text-muted-foreground">{{ $t('hero.bullet2') }}</span>
                        </div>
                        <div class="flex items-center gap-3">
                            <div class="size-5 rounded-full bg-foreground flex items-center justify-center shrink-0">
                                <svg class="size-3 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </div>
                            <span class="text-muted-foreground">{{ $t('hero.bullet3') }}</span>
                        </div>
                    </div>

                    <!-- CTAs - exact React patterns -->
                    <div class="flex flex-wrap items-center gap-4">
                        <a
                            href="#contact"
                            class="bg-accent hover:bg-accent/90 text-accent-foreground px-6 py-3 rounded-lg transition-all flex items-center gap-2 group uppercase text-sm tracking-wide font-medium"
                            @click.prevent="handleGetStarted"
                        >
                            {{ $t('hero.cta') }}
                            <svg class="size-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                        </a>
                        <a
                            href="#contact"
                            class="border-2 border-border bg-white px-6 py-3 rounded-lg hover:bg-muted transition-all uppercase text-sm tracking-wide font-medium"
                            @click.prevent="handleLearnMore"
                        >
                            {{ $t('hero.learnMore') }}
                        </a>
                    </div>
                </div>

                <!-- Right: Dashboard Image - exact React: rounded-2xl overflow-hidden shadow-2xl -->
                <div class="relative">
                    <div class="rounded-2xl overflow-hidden shadow-2xl">
                        <img
                            src="@/assets/hero-dashboard.webp"
                            :alt="$t('hero.dashboardAlt')"
                            class="w-full h-auto"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Badge from '@/components/atoms/Badge.vue';

export default defineComponent({
    name: 'HeroSection',
    components: {
        Badge
    },
    setup() {
        const handleGetStarted = () => {
            const contact = document.getElementById('contact');
            if (contact) {
                contact.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };

        const handleLearnMore = () => {
            const features = document.getElementById('features');
            if (features) {
                features.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };

        return {
            handleGetStarted,
            handleLearnMore
        };
    }
});
</script>
